var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Welcome to "),_c('b',[_vm._v("White Dashboard")]),_vm._v(" - a beautiful freebie for every web\n  developer.\n")])}]

export { render, staticRenderFns }